import React from 'react';

import styled from 'styled-components';

import ChevronRight from 'common/Icons/ChevronRight';

const ActionPlanCard = styled.div<{ $compact: boolean }>`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  border: 1px solid var(--lighter-gray);
  border-radius: 6px;
  background: var(--background-gray-light);
  padding: ${({ $compact }) => ($compact ? '6px 10px' : '10px 15px')};
  display: flex;
  align-items: center;
  gap: 10px;

  > svg {
    flex-shrink: 0;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const ActionPlanIcon = styled.div<{ $compact: boolean }>`
  width: ${({ $compact }) => ($compact ? '26px' : '30px')};
  height: ${({ $compact }) => ($compact ? '26px' : '30px')};
  border-radius: 6px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(315deg, #5f5fff, #f05fff 50%, #ff5b98 0%);
`;

const ActionPlanTexts = styled.div`
  display: flex;
  min-width: 0;
  flex: 1;
  overflow: hidden;
  flex-direction: column;
  gap: 2px;
`;

const ActionPlanLabel = styled.span`
  font-size: 12px;
  font-family: var(--font-bold);
`;

const ActionPlanName = styled.span`
  display: -webkit-box;
  overflow: hidden;
  font-size: 14px;
  color: var(--dark-blue);
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

type Props = {
  actionPlanName?: string | null;
  onClick?: () => void;
  dataTestId?: string;
  disabled?: boolean;
  isArchived?: boolean;
  compact?: boolean;
};

const AlertActionPlanCard = ({
  actionPlanName,
  onClick,
  dataTestId,
  disabled = false,
  isArchived = false,
  compact = false,
}: Props) => {
  const handleClick = () => {
    if (disabled || !onClick) {
      return;
    }

    onClick();
  };

  return (
    <ActionPlanCard
      data-test-id={dataTestId}
      className={disabled ? 'disabled' : undefined}
      aria-disabled={disabled}
      onClick={handleClick}
      $compact={compact}
    >
      <ActionPlanIcon $compact={compact}>
        <img src="/icons/checklist-white.svg" alt="action-plan" width={16} height={16} />
      </ActionPlanIcon>
      <ActionPlanTexts>
        <ActionPlanLabel>AI-generated Action Plan{isArchived ? ' (Deleted)' : ''}</ActionPlanLabel>
        <ActionPlanName>{actionPlanName || 'View Related Action Plan'}</ActionPlanName>
      </ActionPlanTexts>
      <ChevronRight fill="var(--text-primary)" width={24} height={24} />
    </ActionPlanCard>
  );
};

export default AlertActionPlanCard;
